import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const WEBSITE_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../website/page/page.module').then(m => m.PageModule)
  }
];
